import Slider from './Slider';
import Rail from './Rail';
import Ticks from './Ticks';
import Tracks from './Tracks';
import Handles from './Handles';

Slider.Rail = Rail;
Slider.Ticks = Ticks;
Slider.Tracks = Tracks;
Slider.Handles = Handles;

export default Slider;
export { Rail, Ticks, Tracks, Handles };
